module.exports = __webpack_public_path__ + "static/media/job.feff1440.svg";